import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';

import {
  showContextualAttribute,
  hideContextualAttribute,
  withContextualAttributeTemplate,
} from '@bingads-webui-campaign/recommendation-contextual-attribute';
import { CONTEXTUAL_ENTITY_TYPE, getIconClasses, formatDecimal } from '@bingads-webui-campaign/recommendation-core';

import template from '../template/index.pug';

export class RecommendationSetupConversionTrackingView extends Backbone.View {
  initialize({
    data,
    i18n,
    deps,
    router,
    gridView,
    readOnly,
    isMCC,
    gridService,
    isRecommendationThirdPartyTaggingEnabled,
  }) {
    this.opportunityData = _.first(data.Opportunities);
    this.type = data.OpportunityType;
    this.i18n = i18n;
    this.data = data;
    this.deps = deps;
    this.router = router;
    this.grid = { gridView };
    this.readOnly = readOnly;
    this.isMCC = isMCC;
    this.timerForPopupContextualAttribute = null;
    this.gridService = gridService;
    this.isRecommendationThirdPartyTaggingEnabled = isRecommendationThirdPartyTaggingEnabled;
  }

  get events() {
    return {
      'click .btn-primary': this.getStarted,
      'click .btn-cancel': this.cancel,
      'mouseover .recommendation-setup-conversion-tracking .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .recommendation-setup-conversion-tracking .contextual-tooltip': 'hideContextualAttributePopup',
      'click .recommendation-setup-conversion-tracking .contextual-tooltip': 'scopeRouting',
    };
  }

  scopeRouting(e) {
    this.router(e);
  }

  hideContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    hideContextualAttribute({ e, self: this });
  }

  showContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    this.timerForPopupContextualAttribute = setTimeout(() => {
      showContextualAttribute({
        deps: this.deps,
        i18n: this.i18n,
        e,
        type: this.type,
        isExpanding: true,
        self: this,
        recommendationService: this.gridService.recommendationService,
      });
    }, 500);
  }

  render() {
    const {
      i18n,
      opportunityData: {
        OpportunityId: opportunityId,
        Target: target,
        StatusId: statusId,
        NumClicks: numClicks,
        NumImpressions: numImpressions,
      },
    } = this;

    const accountName = this.isMCC ? withContextualAttributeTemplate({
      opportunityId,
      entityName: target.AccountName,
      entityId: target.AccountId,
      entityType: CONTEXTUAL_ENTITY_TYPE.ACCOUNT,
      status: 'false',
      isExpandingView: true,
    }) : '';

    const title = statusId === 2 ?
      'Recommendation_Grid_SetupConversionTrackingOpportunity_Unverified_Todo_Title_MCC' :
      'Recommendation_Grid_SetupConversionTrackingOpportunity_UnCreated_Todo_Title_MCC';

    const iconClasses = getIconClasses(statusId, 3);

    this.$el.html(template({
      i18n,
      title: i18n.getString(title, { accountName }),
      iconClasses,
      numClicks: formatDecimal(numClicks, i18n),
      numImpressions: formatDecimal(numImpressions, i18n),
      isRecommendationThirdPartyTaggingEnabled: this.isRecommendationThirdPartyTaggingEnabled,
    }));

    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  cancel() {
    this.trigger('cancel');
  }
}
